import { setUnitQty } from '../i18n/unitQtyWrapper';
import {
  REQUEST_CURRENT_USER_DETAILS,
  RECEIVE_CURRENT_USER_DETAILS,
} from '../constants/actionTypes';

export const initialState = {
  hasFetched: false,
};

/**
 * Handles redux state for current user details
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function currentUserReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_CURRENT_USER_DETAILS: {
      return {
        ...state,
        id: action.id,
        hasFetched: false,
      };
    }
    case RECEIVE_CURRENT_USER_DETAILS: {
      const { countryCode, preferences } = action.userDetails;
      setUnitQty(preferences.unitsOfMeasureTemplateName, countryCode);
      return {
        ...state,
        ...action.userDetails,
        hasFetched: true,
      };
    }
    default: {
      return state;
    }
  }
}

export default currentUserReducer;
